import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, RoutesRecognized } from '@angular/router';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { filter, map, pairwise } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EFeatureToggles } from '../configurations/common';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly configFacade: ConfigurationFacade = inject(ConfigurationFacade);

  currentRoutePath: string = '';
  previousRoutePath: string = '';

  canActivate(): Observable<boolean> {
    return this.configFacade.isFeatureEnabled(EFeatureToggles.MAINTENANCE).pipe(map((maintenanceEnabled: boolean) => {
      this.router.events.pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
      ).subscribe({
        next: (event: RoutesRecognized[]) => {
          if (event.length >= 1) {
            this.previousRoutePath = event[1].urlAfterRedirects;
          }
          this.currentRoutePath = event[0]['url']?.split('/').findLast(Boolean) ?? '';
        },
      });

      if (maintenanceEnabled) {
        if (this.previousRoutePath.endsWith('.')) {
          this.router.navigate(['.']);
          return true;
        }
        this.router.navigate(['page-maintenance']);
        return false;
      }
      if (this.currentRoutePath === 'page-maintenance') this.router.navigate(['.']);
      return true;
    }));
  }
}
